
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { mask } from "vue-the-mask";
import moment from "moment";

export default {
  name: "app-link-ordem-compra",
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  directives: {
    mask,
    "number-only": {
      bind(el) {
        function checkValue(event) {
          event.target.value = event.target.value.replace(/[^0-9]/g, "");
          if (event.charCode >= 48 && event.charCode <= 57) {
            return true;
          }
          event.preventDefault();
        }
        el.addEventListener("keypress", checkValue);
      },
    },
    "letter-only": {
      bind(el) {
        function checkValue(event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault();
          }
          return true;
        }
        el.addEventListener("keypress", checkValue);
      },
    },
  },
  data() {
    return {
      uuid: null,
      allStatus: [],
      dataFetched: false,
      fornecedor: null,
      emissor: null,
      data_solicitacao: null,
      observacao: null,
      pagamentos: [],
      produtos: null,
      status: null,
      valorTotal: null,
      numero: null,
      finished: false,
      contatoResposta: null,
      windowWidth: window.innerWidth,
      dataResposta: null,
      solicitante: null,
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["pageTitle", "layoutConfig"]),
    tableItems() {
      return this.produtos.map((produto) => ({
        codigo: produto.product?.codigo,
        nome: produto.product.descricao,
        quantidade: produto.quantity,
        preco: this.numberToReal(produto.price, 2),
        total: this.numberToReal(produto.totalPrice, 2),
        _showDetails: true,
      }));
    },
    produtoObservacoes() {
      return this.produtos.map((produto) => produto?.product?.obs);
    },
    isMobile() {
      return this.windowWidth < 569;
    },
    cardStyle() {
      return {
        width: this.isMobile ? "94vw" : "",
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    getProdutoObservacao(row) {
      const observacaoIndex = this.tableItems.findIndex(
        (el) => el.codigo === row.item.codigo
      );
      if (observacaoIndex === -1) return null;
      return this.produtoObservacoes[observacaoIndex];
    },
    tablePagamentoItems(index) {
      return this.pagamentos[index].range.map((parcela, index) => ({
        parcela: index + 1,
        "Valor R$": this.numberToReal(parcela.value, 2),
        vencimento: moment(parcela.date).format("DD/MM/YYYY"),
      }));
    },
  },
  async mounted() {
    const { uuid } = this.$route.params;
    this.setLoading(true);
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    this.$http
      .post("/ordemcompra/busca-ordem-compra", {
        uuid,
      })
      .then(({ data }) => {
        this.fornecedor = data.fornecedor;
        this.emissor = data.emissor;
        this.data_solicitacao = data.data_solicitacao;
        this.observacao = data.observacao;
        this.pagamentos = data.pagamentos;
        this.produtos = data.produtos;
        this.status = data.status;
        this.valorTotal = data.valorTotal;
        this.numero = data.numero;
        this.dataFetched = true;
        this.setLoading(false);
      })
      .catch((error) => {
        this.setLoading(false);
        this.$toast.error(`Erro ao buscar ordem:\n${error}`);
      });
    await this.getInit();
  },
  created() {},
};
